import "./TabGroupComponent.scss";
import React, {useCallback, useEffect} from "react";
import commonService from "../../services/common.service";
import {useLocation, useSearchParams} from "react-router-dom";


export interface TabItemType {
    title: string;
    id: string;
    disabled?: boolean;
}

interface TabGroupComponentProps {
    tabs: TabItemType[];
    selectedTabId?: string;
    searchParamsName?: string;
    onTabSelection?: (selectedTabId: string) => void;
    height?: number;
    actions?: any;
}

const TabGroupComponent = (props: TabGroupComponentProps) => {
    const [, setSearchParams] = useSearchParams();
    const location = useLocation();

    const {tabs, selectedTabId, actions, onTabSelection, searchParamsName = "active-tab"} = props;

    const handleTabSelection = useCallback((selectedTabId: string) => {
        if (onTabSelection && selectedTabId !== props.selectedTabId) {
            onTabSelection(selectedTabId);
            const query = commonService.parseQueryString(location.search)
            setSearchParams({
                ...query,
                [searchParamsName]: selectedTabId
            });
        }
    }, [onTabSelection, props.selectedTabId, location.search, setSearchParams, searchParamsName]);

    useEffect(() => {
        const query = commonService.parseQueryString(location.search)
        if (query[searchParamsName] && onTabSelection) {
            onTabSelection(query[searchParamsName]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="tab-group-component">
            <div className="tab-group-container">
                {tabs.length &&
                    tabs.map((tab, index) => {
                        return (
                            <div
                                className={'tab-wrapper ' + (tab?.disabled ? 'disabled' : '') + ' ' + (selectedTabId === tab.id ? 'active' : 'default')}
                                key={'TabGroupsComponent-' + tab?.id + index}
                                onClick={() => {
                                    if (!tab.disabled) {
                                        handleTabSelection(tab.id);
                                    }
                                }}
                            >
                                <div className={'tab-text'}>
                                    {tab.title}
                                </div>
                            </div>
                        );
                    })}
            </div>
            {actions && <div className="tab-actions">
                {actions}
            </div>}
        </div>
    );

};

export default TabGroupComponent;


// ****************************** USAGE *************************

// import TabGroupComponent, {TabItemType} from "../../shared/components/tab-group/TabGroupComponent";
//
// const LiveVehicleListTabs: TabItemType[] = [
//     {
//         title: "All Vehicles",
//         id: "all-vehicles"
//     },
//     {
//         title: "Handover Vehicles",
//         id: "handover-vehicles"
//     }
// ];
//
// const [liveVehicleListActiveTab, setLiveVehicleListActiveTab] = useState<string>(LiveVehicleListTabs[0].id);
// const handleLiveVehicleListTabChange = useCallback((tabId: string) => {
//     setLiveVehicleListActiveTab(tabId);
// }, []);
//
// <TabGroupComponent
//     selectedTabId={liveVehicleListActiveTab}
//     tabs={LiveVehicleListTabs}
//     onTabSelection={handleLiveVehicleListTabChange}
// />
//
// {
//     liveVehicleListActiveTab === LiveVehicleListTabs[1].id && <>
//         Handover Vehicles
//     </>
// }

// ****************************** USAGE *************************
